import { Badge } from "antd-mobile";
import React from "react";
import { useNavigate } from "react-router-dom";

import { getUserCurrency } from "../../../../plugins/utils";
import { useGetUnreadCount } from "../../../SystemAnnouncement/hooks/systemAnnoucement.hook";
import { useGetCSLink } from "../../hooks/personal.hook";
import CustomerService from "../../icons/CustomerService";
import Notification from "../../icons/Notification";
import styles from "./style.module.scss";

const userCurrency = getUserCurrency();

function Header({ currentDate }) {
  const navigate = useNavigate();
  const getUnreadCount = useGetUnreadCount({});
  const getCSLink = useGetCSLink({
    userCurrency: userCurrency,
  });
  return (
    <div className={styles.personalHeader}>
      <div className={styles.date}>{currentDate}</div>
      <div className={styles.iconBox}>
        <div
          className={styles.icon}
          onClick={() => {
            if (getCSLink.data) window.location.href = getCSLink.data;
            return;
          }}
        >
          <CustomerService />
        </div>
        <Badge
          content={getUnreadCount.data ? Badge.dot : ""}
          style={{
            "--top": "10%",
            "--right": "15%",
            width: "12px",
            height: "12px",
            borderRadius: "6px",
          }}
        >
          <div
            className={styles.icon}
            onClick={() => {
              navigate("/personal/announcement");
            }}
          >
            <Notification />
          </div>
        </Badge>
      </div>
    </div>
  );
}

export default Header;
